export default class {

    constructor (lodash, SiteService, PrivilegeService, UserResource, ROLE_PRIVILEGE_ENUM, ROLE_CODE_ENUM) {
        this.lodash = lodash;
        this.SiteService = SiteService;
        this.PrivilegeService = PrivilegeService;
        this.UserResource = UserResource;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
    }

    /**
     * This method returns direct managers from user expand relation "userDirectManagers"
     * Each relation entry is validated against validDirectManagers
     * validDirectManagers contains all direct managers that are visible for current user
     * @param user
     * @param validDirectManagers
     * @returns {Array}
     */
    getChosenManagers (user, validDirectManagers) {
        const directManagers = [];
        const managerUserIds = validDirectManagers.map((managerUser) => managerUser.id);

        user.directManagers.forEach(manager => {
            user.userDirectManagers.forEach(userManager => {
                if (userManager.managerId === manager.id
                    && this.lodash.includes(managerUserIds, userManager.managerId)) {
                    manager.isManuallyAdded = userManager.isManuallyAdded;
                    directManagers.push(manager);
                }
            });
        });
        return directManagers;
    }

    queryDirectManagersByPrivileges (privileges = [this.ROLE_PRIVILEGE_ENUM.KEYS.EMPLOYEE_MANAGE], extraParams = []) {
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER,
            pageSize: 0
        };

        if (extraParams) {
            this.lodash.merge(params, extraParams);
        }

        if (this.PrivilegeService.isCompanyAdmin()) {
            return this.UserResource.query(params).$promise;
        }

        // if user has no admin privilege then filter managers by site
        const siteIds = this.SiteService.getSitesByPrivileges(
            privileges, true
        ).map((site) => site.id);

        params['siteIds[]'] = siteIds.length ? siteIds : [-1];

        return this.UserResource.query(params).$promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/user/manager/index.js